import api from './axiosConfig';
import { handleApiError } from './errorHandler';

/**
 * Get best selling items by metric type
 * @param {string} metricType - Metric type ('quantity', 'weight', 'jars', or 'profit')
 * @param {number} days - Number of days to analyze (default: 30)
 * @param {number} top - Number of top items to return (default: 10)
 * @param {Array<number>} categoryIds - Optional array of category IDs to filter by
 * @param {string} comparisonType - Comparison type ('previous_period', '1_year', '2_years', '3_years')
 * @returns {Promise} API response with best sellers data
 */
export const getBestSellers = async (metricType, days = 30, top = 10, categoryIds = [], comparisonType = 'previous_period') => {
    try {
        const params = {
            metric_type: metricType,
            days,
            top,
            comparison_type: comparisonType,
        };

        // Add category_ids if provided
        if (categoryIds && categoryIds.length > 0) {
            params.category_ids = categoryIds.join(',');
        }

        const { data } = await api.get('/api/analytics/best-sellers/', { params });
        return data;
    } catch (error) {
        handleApiError(error, 'Get best sellers error:');
        throw error;
    }
};

/**
 * Get slow selling items by metric type
 * @param {string} metricType - Metric type ('quantity', 'weight', 'jars', or 'profit')
 * @param {number} days - Number of days to analyze (default: 30)
 * @param {number} top - Number of bottom items to return (default: 10)
 * @param {Array<number>} categoryIds - Optional array of category IDs to filter by
 * @param {string} comparisonType - Comparison type ('previous_period', '1_year', '2_years', '3_years')
 * @returns {Promise} API response with slow sellers data
 */
export const getSlowSellers = async (metricType, days = 30, top = 10, categoryIds = [], comparisonType = 'previous_period') => {
    try {
        const params = {
            metric_type: metricType,
            days,
            top,
            comparison_type: comparisonType,
        };

        // Add category_ids if provided
        if (categoryIds && categoryIds.length > 0) {
            params.category_ids = categoryIds.join(',');
        }

        const { data } = await api.get('/api/analytics/slow-sellers/', { params });
        return data;
    } catch (error) {
        handleApiError(error, 'Get slow sellers error:');
        throw error;
    }
};

export const analyticsAPI = {
    getBestSellers,
    getSlowSellers,
};
